// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3JUZp","select":"Header_select__3JbUF","clinic":"Header_clinic__2OszA"};